'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../external/@babel/runtime/helpers/esm/extends.js');

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../external/classnames/index.js');

var reactSwipeable = require('react-swipeable');

require('../Alert/Alert.js');

require('../Article/Article.js');

require('../ArticleInfoBlock/ArticleInfoBlock.js');

require('../Banner/Banner.js');

require('../BreadCrumbs/BreadCrumbs.js');

require('../FeatureCarousel/FeatureCarousel.js');

require('../FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');

require('../FeaturedMarquee/FeaturedMarquee.js');

require('../NewsletterSubscription/NewsletterSubscription.js');

require('../OpenPositions/OpenPositions.js');

require('../OurTeam/OurTeam.js');

require('../PageHeader/PageHeader.js');

var Pagination = require('../Pagination/Pagination.js');

require('../PanelGroup/PanelGroup.js');

require('../PanelGroup/Panel/Panel.js');

require('../PodcastCarousel/PodcastCarousel.js');

require('../SecondaryNav/SecondaryNav.js');

var Section = require('../Section/Section.js');

var SectionHeader = require('../Section/SectionHeader/SectionHeader.js');

require('../SplitBanner/SplitBanner.js');

require('../SplitBanner/SplitBannerImage/SplitBannerImage.js');

require('../SplitBanner/SplitBannerVideo/SplitBannerVideo.js');

require('../SplitBanner/SplitBannerContent/SplitBannerContent.js');

require('../SplitBanner/SplitBannerContact/SplitBannerContact.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var PaginationContainer = function PaginationContainer(_ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      className = _ref.className,
      data = _ref.data,
      header = _ref.header,
      link = _ref.link,
      linkText = _ref.linkText,
      pageSize = _ref.pageSize,
      scrollId = _ref.scrollId,
      setDataDisplay = _ref.setDataDisplay;
  var pageRef = React.useRef();
  var handlers = reactSwipeable.useSwipeable({
    onSwipedLeft: function onSwipedLeft() {
      var nextPage = pageRef.current.currentPage + 1;
      return nextPage <= pageRef.current.lastPage && pageRef.current.setCurrentPage(nextPage);
    },
    onSwipedRight: function onSwipedRight() {
      var nextPage = pageRef.current.currentPage - 1;
      return nextPage >= 1 && pageRef.current.setCurrentPage(nextPage);
    }
  });
  var classes = index['default']('pagination-container', className);

  var renderSectionHeader = function renderSectionHeader() {
    return header && /*#__PURE__*/React__default['default'].createElement(SectionHeader.SectionHeader, {
      link: link,
      linkText: linkText,
      title: header
    });
  };

  return /*#__PURE__*/React__default['default'].createElement(Section.Section, {
    className: classes,
    id: scrollId,
    backgroundColor: backgroundColor
  }, renderSectionHeader(), /*#__PURE__*/React__default['default'].createElement("div", _extends['default']({
    className: "data-wrapper"
  }, handlers), children), /*#__PURE__*/React__default['default'].createElement(Pagination.Pagination, {
    data: data,
    pageSize: pageSize,
    onPageChange: setDataDisplay,
    ref: pageRef,
    scrollId: scrollId
  }));
};

PaginationContainer.defaultProps = {
  data: [],
  pageSize: 10
};
PaginationContainer.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  data: PropTypes__default['default'].array.isRequired,
  setDataDisplay: PropTypes__default['default'].func.isRequired,
  backgroundColor: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  header: PropTypes__default['default'].string,
  link: PropTypes__default['default'].string,
  linkText: PropTypes__default['default'].string,
  pageSize: PropTypes__default['default'].number,
  scrollId: PropTypes__default['default'].string
};
exports.PaginationContainer = PaginationContainer;
exports['default'] = PaginationContainer;